const LOADING = "loading"
const ERROR = "error"
const WAITING = "waiting"

// GAME STATUSES
const CHOICE = "choice"
const DEALING = "dealing"
const GAME = "game"

// GAME STAGES
const PRE_FLOP = 'preflop'
const FLOP = 'flop'
const TURN_RIVER = 'turnriver'
const BUSY = "busy"

const statusList = [PRE_FLOP, FLOP, TURN_RIVER]

export { LOADING, ERROR, WAITING, CHOICE, PRE_FLOP, FLOP, TURN_RIVER, BUSY, DEALING, GAME, statusList } 